// 统一请求路径前缀在commmon/axios.js中修改
import { getRequest, postRequest,postRequestLogin,putRequest,putNoToken,getRequestWithNoToken } from '../assets/js/api';

// 获取游戏可玩时长
export const _getPlayTimeLimit = (params) => {
   return getRequest('/api-content/game/playTimeLimit', params)
 }

// 标识游戏开始
export const _getGameStart= (params) => {
   return postRequest('/api-content/game/start', params)
}
// 标识游戏结束
export const _getGameEnd = (params) => {
   return postRequest('/api-content/game/end', params)
}

// 获取游戏关卡
export const _getGameLevel = (params) => {
   return getRequest('/api-content/game/level', params)
}

// 获取连连看游戏关卡
export const _getGameLevels = (params) => {
   return getRequest('/api-content/game/levels', params)
}

// 设置游戏关卡
export const _setGameLevel = (params) => {
   return postRequest('/api-content/game/level', params)
}

// 查询儿童昵称和标签状态
export const _checkStudentNickName = (studentId,params) => {
   return getRequest(`/api-customer-c/psy_student/checkStudentNickNameLabelStatus/${studentId}`, params)
}

// 设置儿童昵称
export const _setStudentNickName = (params) => {
   return postRequest('/api-customer-c/psy_student/setStudentNickName', params)
}

// 保存儿童标签
export const _setStudentLabel = (params) => {
   return postRequest('/api-customer-c/studentFavoriteLabelCustom/save', params)
}

// 获取儿童标签
export const _queryLabels = (params) => {
   return postRequest('/api-customer-c/studentFavoriteLabelCustom/queryLabels', params)
}

//查询单个儿童所有信息
export const _getChildDetail = (studentId,params) => {
   return getRequest(`/api-customer-c/psy_student/${studentId}`, params)
}

// 设置游戏错误记录
export const _getWrong = (params) => {
   return postRequest(`/api-content/game/wrong`, params)
}

